export interface Version {
  major: number;
  minor: number;
  patch: number;
}

export const getVersionFromString = (version: string): Version => {
  const [major, minor, patch] = version.split(".");

  return {
    major: parseInt(major, 10),
    minor: parseInt(minor, 10),
    patch: parseInt(patch, 10),
  };
};

export const hasAnyNaNs = (version: Version): boolean => {
  return isNaN(version.major) || isNaN(version.minor) || isNaN(version.patch);
};

// a >= b
export const semanticVersionGTE = (versionAString: string, versionBString: string): boolean => {
  const versionA = getVersionFromString(versionAString);
  const versionB = getVersionFromString(versionBString);
  if (hasAnyNaNs(versionA) || hasAnyNaNs(versionB)) {
    return false;
  }

  const majorGT = versionA.major > versionB.major;
  const majorGTE = versionA.major >= versionB.major;
  const minorGT = versionA.minor > versionB.minor;
  const minorGTE = versionA.minor >= versionB.minor;
  const patchGTE = versionA.patch >= versionB.patch;

  return majorGT || (majorGTE && minorGT) || (majorGTE && minorGTE && patchGTE);
};
